export const apiUri = "https://new.dyarko.com";
// export const apiUri = "http://localhost:8000";

export const filterRequest = (filter = {}) => {
  let filterString = ``;
  for (let key in filter) {
    filterString += `&${key}=${filter[key]}`;
  }
  return filterString;
}